/* ==========================================================================
   Ürün detay — varyant seçimi, galeri, tam ekran görsel, boy hesaplayıcı,
   mobil yapışkan çubuk.

   Fiyat metinleri Liquid tarafında biçimlenip data-price özniteliğine
   gömülüyor; burada yalnızca metin değiştiriliyor. JS'te para biçimlendirme yok.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-km-product]');
  if (!root) return;

  /* ------------------------------------------------ butondaki satır toplamı
     Prototipte buton "Sepete ekle — 33.000 TL" biçiminde. Tutar hem varyant
     hem adet değişince güncellenir. Biçimlendirme snippets/price.liquid ile
     aynı: binlik ayırıcı nokta, sonda " TL".
  */

  var currentCents = 0;

  function formatTRY(cents) {
    var whole = Math.floor(cents / 100);
    var s = String(whole);
    var out = '';
    while (s.length > 3) {
      out = '.' + s.slice(-3) + out;
      s = s.slice(0, -3);
    }
    return s + out + ' TL';
  }

  function renderAddTotal(available) {
    var el = root.querySelector('[data-km-add-total]');
    if (!el) return;

    if (!available || !currentCents) {
      el.hidden = true;
      el.textContent = '';
      return;
    }

    var qtyInput = root.querySelector('[data-km-qty-input]');
    var qty = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;

    el.hidden = false;
    el.textContent = '— ' + formatTRY(currentCents * qty);
  }

  /* -------------------------------------------------------- varyant seçimi */

  function initVariants() {
    var radios = root.querySelectorAll('[data-km-variant]');
    if (!radios.length) return;

    var priceEl = root.querySelector('[data-km-price]');
    var stockEl = root.querySelector('[data-km-stock]');
    var skuEl = root.querySelector('[data-km-sku]');
    var addBtn = root.querySelector('[data-km-add-button]');
    var addLabel = root.querySelector('[data-km-add-label]');
    var stickyPrice = document.querySelector('[data-km-sticky-price]');
    var stickySize = document.querySelector('[data-km-sticky-size]');

    function apply(radio) {
      var available = radio.getAttribute('data-available') === 'true';

      if (priceEl) priceEl.textContent = radio.getAttribute('data-price');
      if (stockEl) stockEl.textContent = radio.getAttribute('data-stock');
      if (stickyPrice) stickyPrice.textContent = radio.getAttribute('data-price');
      if (stickySize) stickySize.textContent = radio.getAttribute('data-size');

      var sku = radio.getAttribute('data-sku');
      if (skuEl) {
        if (sku) {
          skuEl.textContent = 'Ürün kodu: ' + sku;
          skuEl.hidden = false;
        } else {
          skuEl.hidden = true;
        }
      }

      if (addBtn) addBtn.disabled = !available;
      if (addLabel) addLabel.textContent = available ? 'Sepete ekle' : 'Tükendi';

      currentCents = Number(radio.getAttribute('data-price-cents')) || 0;
      renderAddTotal(available);

      root.querySelectorAll('.km-product__size').forEach(function (label) {
        label.classList.toggle('is-active', label.contains(radio));
      });

      // Adres çubuğundaki variant parametresini güncelle (paylaşılabilir link).
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      }
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) apply(radio);
      });
    });
  }

  /* ------------------------------------------------------------ adet artır/azalt */

  function initQty() {
    var input = root.querySelector('[data-km-qty-input]');
    if (!input) return;

    root.querySelectorAll('[data-km-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = Number(btn.getAttribute('data-km-qty-step'));
        var next = Math.max(1, (Number(input.value) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    // Adet değişince butondaki tutar da güncellensin (elle yazılan değer dahil).
    input.addEventListener('change', function () {
      var addBtn = root.querySelector('[data-km-add-button]');
      renderAddTotal(!addBtn || !addBtn.disabled);
    });
    input.addEventListener('input', function () {
      var addBtn = root.querySelector('[data-km-add-button]');
      renderAddTotal(!addBtn || !addBtn.disabled);
    });
  }

  /* ------------------------------------------------------------------ galeri */

  var images = [];
  var currentIndex = 0;

  function initGallery() {
    var thumbs = root.querySelectorAll('[data-km-thumb]');
    var main = root.querySelector('[data-km-main-image]');
    if (!thumbs.length) return;

    thumbs.forEach(function (thumb) {
      images.push({
        full: thumb.getAttribute('data-km-full'),
        src: thumb.getAttribute('data-km-src'),
        srcset: thumb.getAttribute('data-km-srcset'),
      });

      thumb.addEventListener('click', function () {
        currentIndex = Number(thumb.getAttribute('data-km-thumb'));
        if (main) {
          main.src = thumb.getAttribute('data-km-src');
          main.srcset = thumb.getAttribute('data-km-srcset');
        }
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
        });
      });
    });
  }

  /* --------------------------------------------------------------- lightbox */

  function initLightbox() {
    var box = document.querySelector('[data-km-lightbox]');
    if (!box) return;

    var img = box.querySelector('[data-km-lightbox-image]');
    var counter = box.querySelector('[data-km-lightbox-counter]');
    var opener = null;

    function render() {
      if (images[currentIndex] && img) img.src = images[currentIndex].full;
      if (counter) counter.textContent = currentIndex + 1 + ' / ' + Math.max(images.length, 1);
    }

    function step(delta) {
      if (!images.length) return;
      currentIndex = (currentIndex + delta + images.length) % images.length;
      render();
    }

    function onKey(event) {
      if (event.key === 'Escape') close();
      else if (event.key === 'ArrowRight') step(1);
      else if (event.key === 'ArrowLeft') step(-1);
    }

    function open(trigger) {
      opener = trigger;
      box.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);
      render();
      var close = box.querySelector('[data-km-lightbox-close]');
      if (close) close.focus();
    }

    function close() {
      box.hidden = true;
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      if (opener) opener.focus();
    }

    root.querySelectorAll('[data-km-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn);
      });
    });

    box.querySelectorAll('[data-km-lightbox-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    var prev = box.querySelector('[data-km-lightbox-prev]');
    var next = box.querySelector('[data-km-lightbox-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ------------------------------------------------------- boy hesaplayıcı */

  // DATA.md bölüm 4: önerilen aralık = boy + lo … boy + hi
  var LEVELS = {
    baslangic: {
      lo: -16,
      hi: -10,
      note: 'Kısa kayak daha kolay döner, hata affeder. İlk sezonda bu aralık doğru.',
    },
    orta: {
      lo: -10,
      hi: -4,
      note: 'Dengeli aralık. Pistte hem kısa dönüş hem hız istiyorsan orta değeri seç.',
    },
    ileri: {
      lo: -5,
      hi: 2,
      note: 'Uzun kayak yüksek hızda stabil. Kısa yarıçaplı dönüşten çok hız arıyorsan üst değeri seç.',
    },
  };

  function initCalculator() {
    var calc = root.querySelector('[data-km-calc]');
    var toggle = root.querySelector('[data-km-calc-toggle]');
    if (!calc || !toggle) return;

    var range = calc.querySelector('[data-km-calc-range]');
    var heightOut = calc.querySelector('[data-km-calc-height]');
    var result = calc.querySelector('[data-km-calc-result]');
    var levelBtns = calc.querySelectorAll('[data-km-level]');
    var level = 'orta';

    toggle.addEventListener('click', function () {
      var open = calc.hidden;
      calc.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) update();
    });

    levelBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        level = btn.getAttribute('data-km-level');
        levelBtns.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', String(on));
        });
        update();
      });
    });

    if (range) {
      range.addEventListener('input', update);
    }

    /** Mevcut varyantlardan öneriye en yakın olanı bulur. */
    function closestVariant(target) {
      var best = null;
      var bestDiff = Infinity;

      root.querySelectorAll('[data-km-variant]').forEach(function (radio) {
        if (radio.getAttribute('data-available') !== 'true') return;
        var n = parseFloat((radio.getAttribute('data-size') || '').replace(',', '.'));
        if (isNaN(n)) return;
        var diff = Math.abs(n - target);
        if (diff < bestDiff) {
          bestDiff = diff;
          best = radio;
        }
      });

      return best;
    }

    function update() {
      if (!range || !result) return;
      var h = Number(range.value);
      if (heightOut) heightOut.textContent = h;

      var cfg = LEVELS[level];
      var lo = h + cfg.lo;
      var hi = h + cfg.hi;
      var mid = (lo + hi) / 2;

      var match = closestVariant(mid);
      var text = 'Senin için önerilen aralık ' + lo + '–' + hi + ' cm.';

      if (match) {
        text += ' Bu modelde ' + match.getAttribute('data-size') + ' boyunu öneriyoruz.';
      } else {
        text += ' Bu modelde bu aralıkta stokta ölçü yok — bize yaz, tedarik edelim.';
      }

      result.textContent = text + ' ' + cfg.note;
    }

    update();
  }

  /* --------------------------------------------------- mobil yapışkan çubuk */

  function initSticky() {
    var bar = document.querySelector('[data-km-sticky]');
    var form = root.querySelector('[data-km-add-form]');
    var addBtn = root.querySelector('[data-km-add-button]');
    var stickyAdd = bar ? bar.querySelector('[data-km-sticky-add]') : null;
    if (!bar || !form) return;

    if (stickyAdd && addBtn) {
      stickyAdd.addEventListener('click', function () {
        addBtn.click();
      });
    }

    if (!('IntersectionObserver' in window)) return;

    // Asıl "Sepete ekle" görünmüyorsa çubuğu göster.
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.hidden = entry.isIntersecting;
        });
      },
      { rootMargin: '0px 0px -60px 0px' }
    );

    observer.observe(form);
  }

  function init() {
    initVariants();
    initQty();

    // Sayfa açılışında seçili varyantın fiyatını al — apply() henüz
    // çalışmadığı için currentCents aksi halde 0 kalır ve tutar görünmez.
    var checked = root.querySelector('[data-km-variant]:checked');
    if (checked) {
      currentCents = Number(checked.getAttribute('data-price-cents')) || 0;
      var addBtn = root.querySelector('[data-km-add-button]');
      renderAddTotal(!addBtn || !addBtn.disabled);
    }

    initGallery();
    initLightbox();
    initCalculator();
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
